var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M21 15.5v-10c0-.276-.224-.5-.5-.5h-17c-.276 0-.5.224-.5.5v10c0 .276.224.5.5.5h17c.276 0 .5-.224.5-.5zm-1-.5h-16v-9h16v9zM23.5 17h-.5v-12c0-1.102-.897-2-2-2h-18c-1.103 0-2 .898-2 2v12h-.5c-.276 0-.5.224-.5.5v2c0 .827.673 1.5 1.5 1.5h21c.827 0 1.5-.673 1.5-1.5v-2c0-.276-.224-.5-.5-.5zm-21.5-12c0-.552.449-1 1-1h18c.551 0 1 .448 1 1v12h-7.5c-.276 0-.5.224-.5.5v.5h-4v-.5c0-.276-.224-.5-.5-.5h-7.5v-12zm21 14.5c0 .275-.224.5-.5.5h-21c-.276 0-.5-.225-.5-.5v-1.5h8v.5c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-.5h8v1.5z"})));
}

Laptop.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Laptop;

Laptop.default = Laptop;
